/**
 * Kimlik dogrulamasi GEREKTIRMEYEN, aday yuzlu yollar.
 *
 * Wiser FE bir IC ARACTIR: App.tsx, giris yapmamis her ziyaretciyi Keycloak'a
 * yonlendirir. KVKK onay sayfasi bu varsayimi kiran ilk sayfa — adayin
 * Wiser'da hesabi yok ve olmayacak; yetkiyi maildeki tek kullanimlik token
 * tasiyor. Bu liste olmadan aday, gecemeyecegi bir giris ekranina duserdi.
 *
 * Buraya bir yol eklemek, onu INTERNETE ACIK ilan etmek demektir. Eklemeden
 * once sayfanin oturum, rol ya da kisisel veri varsaymadigindan emin olun.
 */
export const PUBLIC_PATH_PREFIXES = ["/kvkk"] as const;

/**
 * Verilen yol public mi. Prefix eslesmesi tam segment sinirinda yapilir:
 * "/kvkk" ve "/kvkk/consent" public, "/kvkkrapor" DEGIL.
 */
export function isPublicPath(pathname: string): boolean {
  const path = (pathname || "").toLowerCase();
  return PUBLIC_PATH_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
}
